/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapGetters } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Rater from "vux/src/components/rater/index.vue"; // this line is trasformed by vux-loader
import { apiGetreturnvisitTaskDetail, apiGetreturnVisitTask, apiPostreturnvisitTaskSubmit } from '@/api';
import CustomFormList from '@/components/CustomFormList';
export default {
  name: 'GeneraVisit',
  components: {
    ViewBox: ViewBox,
    Group: Group,
    XButton: XButton,
    Cell: Cell,
    CellBox: CellBox,
    CustomFormList: CustomFormList,
    Rater: Rater
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    oid: {
      type: String
    }
  },
  data: function data() {
    return {
      loading: false,
      fieldList: [],
      orderInfo: {},
      form: {
        visitField: [],
        satisfaction_state: 100
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    epId: function epId() {
      var normalUrl = location.href.includes('children/account');
      var code = normalUrl ? window.location.href.match(/\w+(?=\/index)/g)[0] : window.location.href.match(/zhongyifu\.cn\/(\w+)/) ? window.location.href.match(/zhongyifu\.cn\/(\w+)/)[1] : '';
      return this.user.epCode || code;
      // window.location.href.match(/(?=\w)\w+(?=\/returnVisit\/)/)[0]
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('globalStore', ['_ApiSession'])), {}, {
    reload: function reload() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 按顺序执行
                if (!_this.epId) {
                  _this.$vux.toast.text(i18n.tc("629"));
                }
                _context.next = 3;
                return apiGetreturnVisitTask({
                  oid: _this.oid,
                  epId: _this.epId
                });
              case 3:
                _context.next = 5;
                return _this._ApiSession();
              case 5:
                _context.next = 7;
                return apiGetreturnvisitTaskDetail({
                  id: _this.oid
                }).then(function (res1) {
                  if (res1.success) {
                    var _res1$data;
                    _this.orderInfo = res1.data;
                    _this.fieldList = ((_res1$data = res1.data) === null || _res1$data === void 0 ? void 0 : _res1$data.list) || [];
                  }
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$refs.customFormList.formValidate().then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
                    var data, res;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 18;
                              break;
                            }
                            data = _objectSpread(_objectSpread({}, _this2.form), {}, {
                              id: _this2.oid
                            });
                            _this2.loading = true;
                            _context2.next = 5;
                            return apiPostreturnvisitTaskSubmit(data, 'post');
                          case 5:
                            res = _context2.sent;
                            setTimeout(function () {
                              _this2.loading = false;
                              _this2.$vux.loading.hide();
                            }, 300);
                            if (!res.success) {
                              _context2.next = 16;
                              break;
                            }
                            _this2.$vux.toast.text(i18n.tc("338"));
                            _context2.next = 11;
                            return apiGetreturnVisitTask({
                              oid: _this2.oid,
                              epId: _this2.epId
                            });
                          case 11:
                            _context2.next = 13;
                            return _this2._ApiSession();
                          case 13:
                            _this2.$router.push({
                              name: 'Home'
                            });
                            _context2.next = 17;
                            break;
                          case 16:
                            _this2.$vux.toast.text(i18n.tc("630"));
                          case 17:
                            _this2.$emit('on-success');
                          case 18:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleJump: function handleJump() {
      var row = this.orderInfo;
      var routeMap = {
        1: {
          name: 'ProjectDetail',
          params: {
            oid: row.oid
          }
        },
        6: {
          name: 'EventDetail',
          params: {
            eventId: row.fk_t_order_id
          }
        },
        53: {
          name: 'RepairRecordDetail',
          query: {
            orderId: row.fk_t_order_id
          }
        }
      };
      this.$router.push(routeMap[row.return_visit_type]);
    }
  }),
  created: function created() {
    this.reload();
  }
};